/* Generic custom Application class for error */
export class AppError {
    constructor(public Message?: string, public ExceptionType?: string, public error?: any) { }
}
